
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface EditPageHeaderProps {
  normalizedUsername: string;
  id: string;
}

export const EditPageHeader = ({ normalizedUsername, id }: EditPageHeaderProps) => {
  return (
    <div className="flex items-center gap-4 mb-8">
      <Button
        variant="ghost"
        size="icon"
        asChild
      >
        <Link to={`/${normalizedUsername}/${id}`}>
          <ArrowLeft className="h-4 w-4" />
        </Link>
      </Button>
      <h1 className="text-3xl font-bold">Edit Recipe</h1>
    </div>
  );
};
